var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { TextInput, Button } from "../";
import { Comment } from ".";
var Wrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var left = _a.left, top = _a.top;
    return "\n    position: absolute;\n    left: ".concat(left, "px;\n    top: ").concat(top, "px;\n    color: white;\n  ");
});
var CommentInput = function (_a) {
    var left = _a.left, top = _a.top, onCancel = _a.onCancel;
    var _b = useState(""), text = _b[0], setText = _b[1];
    var _c = useState(true), isEditMode = _c[0], setEditMode = _c[1];
    var handleChange = useCallback(function (e) {
        setText(e.target.value);
    }, []);
    var handleSubmit = useCallback(function () {
        setEditMode(false);
    }, []);
    var handleCancel = useCallback(function () {
        if (onCancel)
            onCancel();
    }, [onCancel]);
    if (isEditMode) {
        return (React.createElement(Wrapper, { left: left, top: top },
            "Comment",
            React.createElement(TextInput, { value: text, onChange: handleChange }),
            React.createElement(Button, { emphasis: "primary", onClick: handleSubmit }, "Submit"),
            React.createElement(Button, { emphasis: "secondary", onClick: handleCancel }, "Cancel")));
    }
    else {
        return (React.createElement(Comment, { left: left, top: top }, text));
    }
};
export default CommentInput;
var templateObject_1;
